import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  learner: {
    id: 'portal.views.profileLearner.label.learner',
    defaultMessage: 'Learner',
    description: 'Learner label',
  },
  dashboard: {
    id: 'portal.views.profileLearner.label.dashboard',
    defaultMessage: 'Dashboard',
    description: 'Dashboard label',
  },
  yourProfile: {
    id: 'portal.views.profileLearner.label.yourProfile',
    defaultMessage: 'Your Profile',
    description: 'Your Profile label',
  },
  bio: {
    id: 'portal.views.profileLearner.label.bio',
    defaultMessage: 'Bio',
    description: 'Bio label',
  },
  hasEarntThisBadges: {
    id: 'portal.views.profileLearner.label.hasEarntThisBadges',
    defaultMessage: 'Has earnt {lineBreak} These badges',
    description: 'Has earnt these badges label',
  },
  edit: {
    id: 'portal.views.profileLearner.button.edit',
    defaultMessage: 'Edit',
    description: 'Edit alt text',
  },
});

export default messages;
